var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ viewBox: '0 0 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M14 17a1 1 0 001-1v-5a1 1 0 00-2 0v5a1 1 0 001 1zm-4 0a1 1 0 001-1v-5a1 1 0 00-2 0v5a1 1 0 001 1zm-3 2h10V8H7v11zm3-13h4V5h-4v1zm10 0h-4V5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v1H4a1 1 0 000 2h1v12a1 1 0 001 1h12a1 1 0 001-1V8h1a1 1 0 000-2z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function trashMultiselect(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};